import { RouteObject } from 'react-router';
import { BlockProvider } from './BlockProvider';
import { Agreement, History, Plan, Tasks } from './views';

export const route: RouteObject = {
  path: 'planning/:block_id/*',
  element: <BlockProvider />,
  children: [
    {
      index: true,
      element: <Plan />,
    },
    {
      path: 'tasks/:task_id?',
      element: <Tasks />,
    },
    {
      path: 'agreement',
      element: <Agreement />,
    },
    {
      path: 'history',
      element: <History />,
    },
  ],
};
